import styled from "@emotion/styled";
import colors from "styles/colors";
const border = `1px solid ${colors["border-gray"]}`;
export const StyledSocialIconLinkComponent = styled.div`
  border: ${border};
  border-radius: 50%;
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;

  .social-icon {
    height: 10px;
    width: 10px;
  }
`;
